import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { ADD_ON_UPGRADE_PAGE } from '../../constants/ErrorBoundaryNames';
import { SCREENS, UPGRADE_PAGES } from '../../constants/tracking/Locations';
import { withErrorBoundary } from '../ErrorBoundary';
import UpgradeHeroBanner from '../UpgradeHeroBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AddonUpgradePage = ({
  upgradePointApiName,
  upgradeConfig,
  purchaseMotions,
  handlePurchaseMotionButtonClick,
  upgradeSource
}) => {
  useEffect(() => {
    getUsageTracker().setProperties({
      screen: SCREENS.UPGRADE_PAGE,
      subscreen: UPGRADE_PAGES.ADD_ON
    });
    getUsageTracker().track('upgradesInteraction', {
      action: 'viewed upgrade page',
      upgradeSource,
      upgradeKey: upgradeConfig.upgradeKey,
      apiName: upgradePointApiName,
      pageType: UPGRADE_PAGES.ADD_ON
    });
    // keep empty dependency array so not to repeat event and exposure log
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "addon-upgrade-page",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "ADDON_UPGRADE_PAGE"
    }), /*#__PURE__*/_jsx(UpgradeHeroBanner, {
      upgradeConfig: upgradeConfig,
      upgradePointApiName: upgradePointApiName,
      purchaseMotions: purchaseMotions,
      handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick,
      hideBackground: true
    })]
  });
};
export default withErrorBoundary(AddonUpgradePage, {
  boundaryName: ADD_ON_UPGRADE_PAGE
});